module.exports = __webpack_public_path__ + "static/media/1009253.fffb2e1a.png";